import { Injectable, Signal, signal, inject } from '@angular/core';
import { NotificationService } from '../notification/notification.service';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  public isLoading = signal<boolean>(false);
  private notificationService = inject(NotificationService);

  show(): void {
    this.isLoading.set(true);
  }

  hide(): void {
    this.isLoading.set(false);
  }

    /**
   * Handles errors and automatically hides the loading state
   * @param error The error object
   * @param defaultMessage Optional default message if error doesn't have a message
   */
  handleError(error: any, defaultMessage: string = 'Er is een fout opgetreden'): void {
    this.hide();

    // Skip auth-related errors to avoid showing unauthorized messages during token refresh
    if (error?.status === 401) {
      return;
    }

    let message = defaultMessage;

    // Handle different types of errors
    if (error?.status === 404) {
      message = 'De gevraagde gegevens zijn niet gevonden';
    } else if (error?.status === 403) {
      message = 'U heeft geen toegang tot deze gegevens';
    } else if (error?.status === 500) {
      message = 'Er is een serverfout opgetreden';
    } else if (error?.status === 0) {
      message = 'Kan geen verbinding maken met de server';
    } else if (error?.error?.message) {
      message = error.error.message;
    } else if (error?.message) {
      message = error.message;
    }

    this.notificationService.error(message);
  }
}
